module.exports = __webpack_public_path__ + "img/orange.78a086c6.jpg";